module.exports = __webpack_public_path__ + "static/media/kalkulator-kalorii-icon.383bed50.svg";